export default __webpack_public_path__ + "static/media/FifthImageModel.a2a9b421.png";